export default {
    DESCRICAO: 1,
    DESCRICAO_ABREVIADA: 2,
    SIGLA: 3,
    SIGLA_DESCRICAO: 4,
    SIGLA_DESCRICAO_ABREVIADA: 5,
    DESCRICAO_ABREVIADA_DESCRICAO: 6,
    SIGLA_DESCRICAO_ABREVIADA_DESCRICAO: 7,
}